module.exports = __webpack_public_path__ + "static/img/fish10.cbec55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish10.png
// module id = pMMU
// module chunks = 0